($ =>{
  var settings = {
    max_width: '992',
  }, default_thead = [], default_tbody = [];


  /**
   * Check if the layout corresponds to mobile or tablet
   * @returns {boolean}
   */
  function isBreakPoint() {
    return $(window).width() <= settings.max_width;
  }

  /**
   * Change the DOM of the tables. Rows to columns.
   * @returns
   */
  function transposeTable(){
    var tables = $('.container table.transpose-table:not(.transpose)');
    tables.each(function () {
      $(this).addClass('transpose');
      var th = $(this).find('thead th');
      var tr = $(this).find('tbody tr');
      var td = [];
      tr.each(function () {
        if($(this)[0].className){
          var classname = $(this)[0].className;
          $(this).find('td').each(function () {
            $(this).addClass(classname);
          });
        }
        td.push($(this).find('td'));
      });
      var new_rows = [];
      th.each(function (index, value) {
        var new_tr = $('<tr></tr>');
        new_tr.append($(this));

        $.each(td, function () {
          new_tr.append($(this)[index]);
        });
        new_rows.push(new_tr);
      });

      $(this).find('thead').children().each(function () {
        $(this).remove();
      });
      $(this).find('tbody').children().each(function () {
        $(this).remove();
      });
      $(this).find('tbody').append(new_rows);
    });
  }

  /**
   * Revert the change of the DOM to default
   * @returns
   */
  function revertTranspose() {
    var tables = $('.container table.transpose-table.transpose');

    if (tables.length > 0){
      tables.each(function (index, value) {
        $(this).removeClass('transpose');

        $(this).find('thead').remove();
        $(this).find('tbody').remove();

        $(this).append(default_thead[index].clone());
        $(this).append(default_tbody[index].clone());
      });
      default_tbody = [];
      default_thead = [];
    }
  }

  $.fn.transpose = function(options){
    settings = $.extend({}, settings, options );
    //save the initial table DOM for revert after transpose the tables.
    var tables = $('.container table.transpose-table:not(.transpose)');
    tables.each(function () {
      default_thead.push($(this).find('thead').clone());
      default_tbody.push($(this).find('tbody').clone());
    });

    if(isBreakPoint()){
      transposeTable();
    }

    this.on('resize', function() {
      if (isBreakPoint()){
        var tables = $('.container table.transpose-table:not(.transpose)');
        if(tables.length > 0 && default_tbody.length == 0 && default_thead.length == 0){
          tables.each(function () {
            default_thead.push($(this).find('thead').clone());
            default_tbody.push($(this).find('tbody').clone());
          });
        }
        transposeTable();
      } else {
        revertTranspose();
      }
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/transpose-tables.js